export default "__VITE_ASSET__DObYd1Da__"